<template>
  <div class="shop-cart-list-discount">
    <div class="shop-cart-list-column">
      <div
        v-if="isEditable"
        class="shop-cart-list-entry__remove"
      >
        <AppIcon
          v-if="clientStore.isDesktop"
          icon="deselect"
          :is-raw="true"
          @click="removeDiscount(data.id)"
        />
        <AppIcon
          v-else
          icon="trash-bin"
          :is-raw="true"
          @click="removeDiscount(data.id)"
        />
      </div>

      <div class="list-entry-product__image">
        <AppIcon
          class-a="shop-cart-list-discount__icon"
          icon="discount"
          :is-raw="true"
        />
      </div>

      <div class="list-entry-product__information">
        <div class="list-entry-product__title">
          {{ useTranslation('general', 'discounts_and_bons') }}
        </div>
        <div class="list-entry-product__name">
          {{ data.discount?.code }}
        </div>
      </div>
    </div>
    <div class="shop-cart-list-column">
      <div class="shop-cart-list__summary">
        <span
          v-if="!data?.discount?.type === 'Free Shipping'"
        >–</span>  {{ computedDiscountSummary }}
        <span
          v-if="!data?.discount?.type === 'Free Shipping'"
          class="shop-cart-list__summary-mwst"
        >
          {{ useTranslation('general', 'inclusive_mwst') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
    data: {
        type: Object,
        default: () => {},
    },
});

const clientStore = useClientDeviceStore();
const cartStore = useCartStore();
const alertBoxStore = useAlertBoxStore();
const isEditable = inject('is-editable');

const removeDiscount = async () => {
    try {
        await cartStore.removeDiscountFromCart();
    } catch (e) {
        alertBoxStore.setAlertBoxData('error', {
            error_text: useTranslation('general', 'remove_discount_error_message'),
        });
        alertBoxStore.toggleAlertbox();
        useSentryError(e);
    }
};

const computedDiscountSummary = computed(() => {
    switch (props.data.discount?.type) {
    case 'Percentage':
        return `- ${props.data.discount?.discount}%`;
    case 'Fixed Amount':
        return `CHF ${props.data.discount?.discount?.toFixed(2)}`;
    case 'Free Shipping':
        return useTranslation('general', 'free_shipping');
    default:
        return `${props.data.discount?.discount?.toFixed(2)}`;
    }
});
</script>

<style lang="scss" scoped>
.list-entry-product__information {
    @include fluid('max-width', 0px, 600px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0px 20px;
    row-gap: 5px;

    @include tablet {
        max-width: unset;
        justify-content: flex-start;
        margin-top: 5px;
    }
}

.list-entry-product__title {
    @include typo-size('p');
    @include typo-font('light');
}

.shop-cart-list-discount {

    position: relative;
    display: flex;
    justify-content: space-between;
    padding: 20px 0;
    border-top: 2px solid $C_GREY_LIGHT;
    color: $C_GREEN_DARK;
    column-gap: 20px;

    @include tablet {
        @include grid-layout(1);
        row-gap: 15px;
    }

    &:last-child {
        border-bottom: 2px solid $C_GREY_LIGHT;
    }
}

.shop-cart-list-entry__remove {
    display: flex;
    min-width: 45px;
    min-height: 100%;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    @include tablet {
        position: absolute;
        top: 10px;
        right: 5px;
        min-width: unset;
        height: auto;
        min-height: unset;

        .app-icon {
            width: 28px;
        }
    }

    .app-icon {
        width: 18px;
    }
}

.list-entry-product__name {
    @include typo-size('label');
    @include typo-font('regular');

    @include tablet {
        padding-right: 62px;
    }
}

.shop-cart-list-column {
    display: flex;

    &:last-child {
        @include mobile {

            width: 100%;
            justify-content: flex-end;
        }
    }
}

.shop-cart-list__summary {
    @include typo-size('label');
    @include typo-font('regular');

    margin-top: auto;
    margin-bottom: auto;
    color: $C_GREEN_DARK;
}

.shop-cart-list__summary-mwst {
    @include typo-size('nav');
    display: block;
}

.list-entry-product__image {
    @include fluid('width', 60px, 80px);
    @include fluid('height', 60px, 80px);

    overflow: hidden;
    padding: 20px;
    border: 2px solid $C_GREEN_DARK;
    border-radius: 12px;
    background: $C_WHITE;
}
</style>
